import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GroundworksAuthLifecycleService } from '@groundworks/ngx-groundworks-auth';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly auth = inject(GroundworksAuthLifecycleService);

  ngOnInit(): void {
    this.auth.start();
  }

  ngOnDestroy(): void {
    this.auth.stop();
  }
}
